var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultCareerImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_3899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 27.8568C6 27.3705 6.19315 26.9042 6.53697 26.5604C6.88079 26.2166 7.3471 26.0234 7.83333 26.0234H11.5C11.9862 26.0234 12.4525 26.2166 12.7964 26.5604C13.1402 26.9042 13.3333 27.3705 13.3333 27.8568V31.5234C13.3333 32.0097 13.1402 32.476 12.7964 32.8198C12.4525 33.1636 11.9862 33.3568 11.5 33.3568H7.83333C7.3471 33.3568 6.88079 33.1636 6.53697 32.8198C6.19315 32.476 6 32.0097 6 31.5234V27.8568Z",
    stroke: "#F3B7CE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.667 27.8568C31.667 27.3705 31.8601 26.9042 32.204 26.5604C32.5478 26.2166 33.0141 26.0234 33.5003 26.0234H37.167C37.6532 26.0234 38.1195 26.2166 38.4634 26.5604C38.8072 26.9042 39.0003 27.3705 39.0003 27.8568V31.5234C39.0003 32.0097 38.8072 32.476 38.4634 32.8198C38.1195 33.1636 37.6532 33.3568 37.167 33.3568H33.5003C33.0141 33.3568 32.5478 33.1636 32.204 32.8198C31.8601 32.476 31.667 32.0097 31.667 31.5234V27.8568Z",
    stroke: "#F3B7CE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.833 13.1888C18.833 12.7026 19.0262 12.2363 19.37 11.8924C19.7138 11.5486 20.1801 11.3555 20.6663 11.3555H24.333C24.8192 11.3555 25.2856 11.5486 25.6294 11.8924C25.9732 12.2363 26.1663 12.7026 26.1663 13.1888V16.8555C26.1663 17.3417 25.9732 17.808 25.6294 18.1518C25.2856 18.4956 24.8192 18.6888 24.333 18.6888H20.6663C20.1801 18.6888 19.7138 18.4956 19.37 18.1518C19.0262 17.808 18.833 17.3417 18.833 16.8555V13.1888Z",
    stroke: "#F3B7CE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8337 15.9375C16.3949 16.3435 14.164 17.5593 12.5009 19.3887C10.8378 21.2181 9.83945 23.5545 9.66699 26.0208",
    stroke: "#F3B7CE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.167 15.9375C28.6058 16.3435 30.8367 17.5593 32.4998 19.3887C34.1629 21.2181 35.1612 23.5545 35.3337 26.0208",
    stroke: "#F3B7CE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.833 15.0234H7.83301",
    stroke: "#F3B7CE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.167 15.0234H26.167",
    stroke: "#F3B7CE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 15.0208C4.16699 15.5071 4.36015 15.9734 4.70396 16.3172C5.04778 16.661 5.5141 16.8542 6.00033 16.8542C6.48656 16.8542 6.95287 16.661 7.29669 16.3172C7.6405 15.9734 7.83366 15.5071 7.83366 15.0208C7.83366 14.5346 7.6405 14.0683 7.29669 13.7245C6.95287 13.3807 6.48656 13.1875 6.00033 13.1875C5.5141 13.1875 5.04778 13.3807 4.70396 13.7245C4.36015 14.0683 4.16699 14.5346 4.16699 15.0208Z",
    stroke: "#F3B7CE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.167 15.0208C37.167 15.5071 37.3601 15.9734 37.704 16.3172C38.0478 16.661 38.5141 16.8542 39.0003 16.8542C39.4866 16.8542 39.9529 16.661 40.2967 16.3172C40.6405 15.9734 40.8337 15.5071 40.8337 15.0208C40.8337 14.5346 40.6405 14.0683 40.2967 13.7245C39.9529 13.3807 39.4866 13.1875 39.0003 13.1875C38.5141 13.1875 38.0478 13.3807 37.704 13.7245C37.3601 14.0683 37.167 14.5346 37.167 15.0208Z",
    stroke: "#F3B7CE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_3899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0.5 0.355469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCareerImg);
export default __webpack_public_path__ + "static/media/default-career-img.3c8a0f4f1872ba19ca751ce67299510d.svg";
export { ForwardRef as ReactComponent };